export function sendQuizAnalytics(_ref) {
  var quizName = _ref.quizName,
    quizId = _ref.quizId,
    quizStep = _ref.quizStep,
    quizChoice = _ref.quizChoice,
    quizAction = _ref.quizAction;
  var _a;
  var eventData = {
    event: 'quiz_constructor',
    quiz_name: quizName,
    quiz_id: quizId,
    quiz_step: quizStep,
    quiz_action: quizAction
  };
  if (quizChoice) {
    eventData.quiz_choice = quizChoice;
  }
  (_a = window.dataLayer) === null || _a === void 0 ? void 0 : _a.push(eventData);
}